import { faTasks } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Card, Tab, Tabs } from "react-bootstrap";
import { Plus, PlusLg } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { workItemTypes } from "../../store/api/CommonFunctions";
import ReferredToMe from "../Components/WorkItemsList/ReferredToMe";
import MonitorByMe from "../Components/WorkItemsList/MonitorByMe";
import ReportedByMe from "../Components/WorkItemsList/ReportedByMe";
import ModalCreateEditWorkItems from "./ModalCreateEditWorkItems";

export default function TaskList() {
    const history = useHistory();
    const [activeTab, setActiveTab] = useState("refToMe");
    //#region  functions
    const handleGoToNewTask = () => {
        history.push(`/Projects/CreateEditWorkItem/false/0`);
    }
    const handleSelectTab = (key) => {
        setActiveTab(key);
    }
    const checkIsActive = (key) => {
        return activeTab === key;
    }
    //#endregion
    useEffect(() => {
        document.body.className = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
            <br />
            <Card style={{ minHeight: '80vh' }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faTasks} size="lg" />&nbsp;
                    <h5 style={{ display: "inline-block" }}>وظایف</h5>

                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Tabs className="custom-tabs"
                        activeKey={activeTab}
                        onSelect={handleSelectTab}>
                        <Tab eventKey="refToMe" title="به من ارجاع شده">
                            <div className="mt-4" style={{ textAlign: "right" }}>
                                <Button onClick={handleGoToNewTask}><PlusLg size={18} />&nbsp;وظیفه جدید</Button>
                            </div>
                            <ReferredToMe type={workItemTypes.task} isActive={checkIsActive("refToMe")} />
                        </Tab>
                        <Tab eventKey="monitorByMe" title="من پیگیری می کنم"
                        >
                            <MonitorByMe type={workItemTypes.task} isActive={checkIsActive("monitorByMe")} />
                        </Tab>
                        <Tab eventKey="reportedByMe" title="من گزارش کرده‌ام"
                        >
                            <ReportedByMe type={workItemTypes.task} isActive={checkIsActive("reportedByMe")} />
                        </Tab>
                    </Tabs>
                </Card.Body>
            </Card>
        </div>
    )
}